/**
 * Словник: da.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_da.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ Venter på den anden deltager...",
  connectionLost: "Forbindelsen blev afbrudt",
  peerLeft: "👋 Den anden deltager forlod opkaldet",
  connectionError: "🚫 Forbindelsesfejl",
  connectionFailedTryAgain: "🚫 Kunne ikke oprette forbindelse til serveren. Prøv igen.",
  reconnectionFailed: "🚫 Forbindelsen blev afbrudt. Den kunne ikke genoprettes efter {attempts} forsøg.",
  connectionErrorWithDetails: "🚫 Forbindelsesfejl: {error}",
  speakerLoud: "Højt",
  speakerEar: "Øre",
  copyRoomId: "Kopiér rum-ID",
  share: "Del",
  linkCopied: "🔗 Link kopieret!",
  idCopied: "🆔 ID kopieret!",
  startMeeting: "Start møde",
  chooseAction: "Vælg en handling",
  createNewRoom: "Nyt rum",
  scheduleCall: "Planlæg opkald",
  calendarOpened: "📅 Kalenderen er åbnet",
  linkCopiedToClipboard: "🔗 Linket er kopieret til udklipsholderen",
  enterRoomId: "Indtast rum-ID",
  roomIdValidationError: "Rum-ID'et må kun indeholde bogstaver, tal og bindestreger",
  joinRoom: "DELTAG",
  termsAndPrivacyHelp: "Vilkår og privatliv | Hjælp",
  invite: "Inviter",
  mySettings: "Mine indstillinger",
  peerSettings: "Den andens indstillinger",
  blockRemoteControl: "Bloker fjernstyring",
  iAgreeToTerms: "Jeg accepterer vilkårene for tjenesten",
  termsOfUse: "Vilkår for brug",
  privacyPolicy: "Privatlivspolitik",
  howToUse: "Sådan fungerer det",
  termsAcceptanceRequired: "Du skal acceptere vilkårene for at bruge tjenesten",
  ok: "OK",
  permissionsRequired: "Tilladelser kræves",
  permissionsNeededMessage: "Appen skal bruge følgende tilladelser for at fungere korrekt:",
  permissionsNote: "Bemærk: Når du ændrer tilladelser i Indstillinger, genstarter iOS appen. Det er helt normalt.",
  permissionsEnableMessage: "Slå disse tilladelser til i enhedens indstillinger for at fortsætte.",
  cancel: "Annuller",
  openSettings: "Åbn indstillinger",
  websocketError: "WebSocket-fejl",
  roomFull: "Rummet er fuldt",
  timeExpired: "Tiden er gået",
  remaining: "tilbage",
  mediaPermissionsRequired: "Videoopkald kræver adgang til kamera og mikrofon. Giv tilladelse i din browser.",
  mediaPermissionsRequiredMobile: "Videoopkald kræver adgang til kamera og mikrofon. Giv tilladelse i appens indstillinger.",
  browserSettings: "Browserindstillinger",
  openAppSettings: "Åbn indstillinger",
  grantPermissions: "Giv tilladelse",
  permissionsNotGranted: "Tilladelserne er ikke givet. Giv tilladelse for at fortsætte.",
  permissionRequestError: "Fejl ved anmodning om tilladelser: {error}",
  camera: "Kamera",
  microphone: "Mikrofon",
  cameraDescription: "Til overførsel af video",
  microphoneDescription: "Til overførsel af lyd",
  continueWithoutPermissions: "Fortsæt uden tilladelser",
  mediaPermissionsRequiredFallback: "Videoopkald kræver medietilladelser. Giv tilladelse i browserens indstillinger.",
  mediaPermissionsRequiredMobileFallback: "Videoopkald kræver medietilladelser. Giv tilladelse i appens indstillinger.",
  browserSettingsFallback: "Browserindstillinger",
  openAppSettingsFallback: "Åbn indstillinger",
  permissionsPermanentlyDenied: "Tilladelserne er afvist permanent. Slå dem til i appens indstillinger.",
  continueText: "Fortsæt",
  mirror: "Spejl",
  fitContain: "Tilpas",
  fitCover: "Udfyld",
  switchCamera: "Vend",
  block: "Bloker",
  pip: "PiP",
  mic: "Mikrofon",
  video: "Video",
  speaker: "Højttaler",
  readyToConnect: "Klar til at tale?",
  startOneOnOne: "Start et videoopkald",
  createPrivateLink: "Linket klar på et sekund",
  welcomeExplainer: "Opret et link, og send det til hvem som helst. Det åbnes også uden appen.",
  joinHaveLink: "Har du et link?",
  joinFieldHint: "Indsæt et link eller ID",
  roomInputInvalid: "Indsæt et opkaldslink eller et rum-ID (bogstaver, tal og bindestreger)",
  guestTitle: "Du er inviteret til et videoopkald",
  guestBody: "Rummet er klar. Den anden ser dig, så snart du deltager.",
  guestJoin: "Deltag",
  guestFreeNote: "Det er altid gratis at deltage",
  guestCreateOwn: "Opret mit eget rum",
  guestInvalidTitle: "Linket ser ud til at være ødelagt",
  guestInvalidBody: "Bed om linket igen, eller opret dit eget rum.",
  inviteCardTitle: "Dit rum er klar",
  inviteCardBody: "Send linket til den, du vil tale med",
  inviteShareLink: "Del link",
  inviteCopy: "Kopiér",
  inviteBrowserHint: "Åbnes i alle browsere. Du behøver ikke installere appen.",
  inviteSentHint: "Sendt? Den anden dukker op her, så snart linket bliver åbnet.",
  inviteShareMessage: "Kom med i mit videoopkald på One2One 👋\nÅbn bare linket. Det virker i din browser, og du skal ikke installere noget:\n{link}",
  copyLink: "Kopiér link",
  consentBannerText: "Må vi indsamle brugsstatistik? Den viser os, hvilke funktioner folk bruger. Indhold fra opkald kommer aldrig med.",
  consentAllow: "Tillad",
  consentDeny: "Tillad ikke",
  privacySettingsLink: "Statistikindstillinger",
} as const;
